export const baseCategories = [
  {
    id: "ContextAndEnablers",
    icon: "/Areas/EGH/assets/img/stunting_drivers/context_icon.svg",
    name: "CONTEXT & ENABLERS",
    title: "Basic drivers (context & enablers)",
    subtitle: "BASIC DRIVERS",
    sections: [
      {
        id: "Politicalcommitment",
        title: "Political commitment to nutrition",
      },
      {
        id: "Multisectoralcollaboration",
        title: "Multisectoral collaboration",
      },
      {
        id: "DataandME",
        title: "Data and M&E",
      },
      {
        id: "Targetingofinequalities",
        title: "Targeting of inequalities",
      },
      {
        id: "Donorengagement",
        title: "Donor engagement",
      },
      {
        id: "Socialsectorspending",
        title: "Social sector spending",
      },
      {
        id: "Womensempowerment",
        title: "Women’s empowerment",
      },
    ],
  },
  {
    id: "IncreasedIncome",
    icon: "/Areas/EGH/assets/img/stunting_drivers/increased_income_icon.svg",
    name: "INCREASED INCOME & RESOURCES",
    title: "Increased income & resources",
    subtitle: "UNDERLYING DRIVERS",
    sections: [
      {
        id: "Household-driven",
        title: "Household-driven",
      },
      {
        id: "Socialprotection",
        title: "Social protection",
      },
      {
        id: "Education",
        title: "Education",
      },
    ],
  },
  {
    id: "ImprovedFeeding",
    icon: "/Areas/EGH/assets/img/stunting_drivers/improved_feeding_icon.svg",
    name: "IMPROVED FEEDING PRACTICES & HOUSEHOLD FOOD SECURITY",
    subtitle: "UNDERLYING DRIVERS",
    title: "Improved feeding practices & household food security",
    sections: [
      {
        id: "InfantAndyoungchildfeeding",
        title: "Infant & young child feeding",
      },
      {
        id: "Foodsecurityquality",
        title: "Food security & quality",
      },
    ],
  },
  {
    id: "ImprovedCare",
    icon: "/Areas/EGH/assets/img/stunting_drivers/improved_care_icon.svg",
    name: "IMPROVED CARE & HEALTH SERVICES",
    subtitle: "UNDERLYING DRIVERS",
    title: "Improved care & health services",
    sections: [
      {
        id: "Healthinfrastructure",
        title: "Health infrastructure",
      },
      {
        id: "Maternalcare",
        title: "Maternal care",
      },
      {
        id: "Familyplanning",
        title: "Family planning",
      },
      {
        id: "Treatment",
        title: "Disease treatment",
      },
      {
        id: "Prevention",
        title: "Disease prevention",
      },
    ],
  },
  {
    id: "HealthyHousehold",
    icon: "/Areas/EGH/assets/img/stunting_drivers/healthy_household_icon.svg",
    name: "HEALTHY HOUSEHOLD ENVIROMENT",
    subtitle: "UNDERLYING DRIVERS",
    title: "Healthy household environment",
    sections: [
      {
        id: "WaterSanitationHygiene",
        title: "Water, Sanitation & Hygiene",
      },
      {
        id: "Householdqualities",
        title: "Household qualities",
      },
      {
        id: "Proximitytoservices",
        title: "Proximity to services",
      },
    ],
  },
  {
    id: "ImprovedDietary",
    icon: "/Areas/EGH/assets/img/stunting_drivers/improved_dietary_icon.svg",
    name: "IMPROVED DIETARY INTAKE",
    subtitle: "UNDERLYING DRIVERS",
    title: "Improved dietary intake",
  },
  {
    id: "LackOfDisease",
    icon: "/Areas/EGH/assets/img/stunting_drivers/lack_disease_icon.svg",
    name: "LACK OF DISEASE",
    subtitle: "UNDERLYING DRIVERS",
    title: "Lack of disease",
  },
  {
    id: "IntergenerationalTransfer",
    icon:
      "/Areas/EGH/assets/img/stunting_drivers/intergenerational_transfer_icon.svg",
    name: "INTERGENERATIONAL TRANSFER",
    subtitle: "UNDERLYING DRIVERS",
    title: "Intergenerational transfer",
  },
];
